/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/preset_banner_templates/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdPresetBannerTemplatesId } from "./constants";
import type { EngagementAppGroupIdPresetBannerTemplatesIdResult } from "./types";
import { isEngagementAppGroupIdPresetBannerTemplatesIdResult } from "./validators";

export const getEngagementAppGroupIdPresetBannerTemplatesId = reactQueryFetcherAdapter(
  engagementAppGroupIdPresetBannerTemplatesId,
  (
    signal: AbortSignal,
    appGroupId: string,
    id: string
  ): Promise<EngagementAppGroupIdPresetBannerTemplatesIdResult> => {
    return fetch(`/engagement/${appGroupId}/preset_banner_templates/${id}`, "GET", {}, { signal });
  },
  isEngagementAppGroupIdPresetBannerTemplatesIdResult
);
